/**
 * @generated SignedSource<<c47efb2d68500d48cb47f9fe431c1f2e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type PinnedCommentDisplaySecondary$data = {
  readonly pinnedIssueComment: {
    readonly issueComment: {
      readonly showSpammyBadge: boolean;
    };
  } | null | undefined;
  readonly " $fragmentType": "PinnedCommentDisplaySecondary";
};
export type PinnedCommentDisplaySecondary$key = {
  readonly " $data"?: PinnedCommentDisplaySecondary$data;
  readonly " $fragmentSpreads": FragmentRefs<"PinnedCommentDisplaySecondary">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PinnedCommentDisplaySecondary",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PinnedIssueComment",
      "kind": "LinkedField",
      "name": "pinnedIssueComment",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "IssueComment",
          "kind": "LinkedField",
          "name": "issueComment",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "showSpammyBadge",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Issue",
  "abstractKey": null
};

(node as any).hash = "4858c23a136c38b549c30a56e0e492c5";

export default node;
